export default "__VITE_ASSET__dd7bea6d__"